import { SBSensor } from "features/iot/sensor-batch/models/sensor-batch-models";
import { Sensor } from "features/iot/sensors/models/sensor-models";

export const mapSensorToSBSensor = (sensor: Sensor): SBSensor => {
    return {
        macAddress: sensor?.macAddress,
        serialNumber: sensor?.serialNumber,
        offset: sensor?.configuration?.offset,
        pitch: sensor?.configuration?.pitch,
        numberOfResistiveElements: sensor?.configuration?.numberOfResistiveElements 
            ? sensor?.configuration?.numberOfResistiveElements
            : undefined,
        firmwareRevision: sensor?.configuration?.firmwareRevision,
        hardwareRevision: sensor?.configuration?.hardwareRevision,
        isManufactured: false,
        allocated: false,
        dispatched: false,
        manufacturedDate: undefined,
        details:undefined
    };
};

export const updateSBSensorWithSensor = (sensor: Sensor, existingSBSensor: SBSensor): SBSensor => {
    return {
        ...existingSBSensor, // Retain existing properties
        serialNumber: sensor?.serialNumber,
        numberOfResistiveElements: sensor?.configuration?.numberOfResistiveElements 
            ? sensor?.configuration?.numberOfResistiveElements
            : undefined,
        firmwareRevision: sensor.configuration.firmwareRevision,
        hardwareRevision: sensor.configuration.hardwareRevision,
        pitch: sensor.configuration.pitch,
        offset: sensor.configuration.offset
    };
};
